import { userApi, teamApi } from '../api';

/**
 * Load colleagues for handoff (employees) or assign (admins).
 */
export async function loadColleagueOptions({ user, isAdminOrAbove, isSuperAdmin }) {
  if (isAdminOrAbove) {
    const r = await userApi.getAll();
    let list = (r.data.data || []).filter(e => e.active && e.id !== user?.id);
    if (isSuperAdmin) {
      list = list.filter(e => e.role !== 'SUPER_ADMIN');
    }
    return list;
  }

  const r = await teamApi.getTeam();
  return r.data.data || [];
}
